module.exports = __webpack_public_path__ + "img/builder-icon.ab3efedc.svg";